import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

const OnboardingWelcome = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F7EFE7] to-white dark:from-dark-bg dark:to-dark-card">
      <div className="max-w-2xl mx-auto text-center px-4">
        <div className="mb-8">
          <div className="flex justify-center mb-6">
            <img
              src="https://customer-assets.emergentagent.com/job_5cdedf29-6831-4187-8b3b-d6d324530c65/artifacts/vckerg2u_Skillerate%20Icon%20Only.svg"
              alt="Skillerate"
              className="h-24 w-24"
            />
          </div>
          <h1 className="text-5xl font-bold mb-4 text-[#3A1E10] dark:text-dark-text">
            Welcome to Skillerate! 🎉
          </h1>
          <p className="text-xl text-[#6b7280] dark:text-dark-text-secondary">
            Let's get your creator profile set up in 3 quick steps
          </p>
        </div>
        
        {/* Progress indicator */}
        <div className="flex justify-center gap-2 mb-12">
          <div className="w-20 h-2 bg-[#E98341] rounded-full"></div>
          <div className="w-20 h-2 bg-gray-300 rounded-full"></div>
          <div className="w-20 h-2 bg-gray-300 rounded-full"></div>
        </div>
        
        {/* Features preview */}
        <div className="grid md:grid-cols-3 gap-6 mb-12 text-left">
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="text-4xl mb-3">✨</div>
            <h3 className="font-semibold text-lg mb-2 text-[#3A1E10]">Create Skills</h3>
            <p className="text-sm text-[#6b7280]">Build and share Claude Skills with our visual editor</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="text-4xl mb-3">🚀</div>
            <h3 className="font-semibold text-lg mb-2 text-[#3A1E10]">Get Discovered</h3>
            <p className="text-sm text-[#6b7280]">Share your skills with the Skillerate community</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="text-4xl mb-3">📊</div>
            <h3 className="font-semibold text-lg mb-2 text-[#3A1E10]">Track Impact</h3>
            <p className="text-sm text-[#6b7280]">See how many people install and use your skills</p>
          </div>
        </div>
        
        <Button 
          onClick={() => navigate('/onboarding/profile')}
          className="px-8 py-6 bg-[#E98341] text-white text-lg font-semibold rounded-lg hover:bg-[#c43408] transition-colors"
        >
          Let's Get Started
        </Button>
        
        <p className="text-sm text-[#6b7280] mt-4">
          Takes less than 2 minutes
        </p>
      </div>
    </div>
  );
};

export default OnboardingWelcome;
